<template>
  <div>
    <b-row>
      <b-col>
        <b-table
          v-if="isLoaded"
          ref="work-orders-overtime-table"
          :items="records"
          :fields="columns"
          :busy="isLoadingData"
          :sort-by.sync="sorting.sortBy"
          :sort-desc.sync="sorting.sortDesc"
          @sort-changed="handleSortingChanged"
          no-local-sorting
          show-empty
          responsive
          table
        >
          <template #cell(number)="data">
            <div>
              <b-link :to="{ name: 'work-order', params: { id: data.item.id } }">
                {{ data.item.number }}
              </b-link>
            </div>
            <b-badge
              variant="success"
              class="font-size-sm"
            >
              {{ data.item.status | humanizedFormat | capitalizeFormat }}
            </b-badge>
          </template>
          <template #cell(client_name)="data">
            <b-link :to="{ name: 'client', params: { id: data.item.client_id } }">
              {{ data.item.client_name }}
            </b-link>
          </template>
          <template #cell(location_name)="data">
            <b-link :to="{ name: 'location', params: { id: data.item.location_id } }">
              {{ data.item.store_number }}
            </b-link>
            <div class="text-nowrap font-size-sm">
              {{ data.item.location_name }}
            </div>
            <div
              v-if="data.item.service_name"
              class="font-size-sm"
            >
              <b-link :to="{ name: 'service', params: { id: data.item.service_id } }">
                {{ data.item.service_name }}
              </b-link>
            </div>
          </template>
          <template #cell(description)="data">
            <text-with-popover
              v-if="data.item.description"
              :popover-id="`overtime-${data.item.id}-description`"
              :text="data.item.description"
            />
          </template>
          <template #cell(assigned_to_name)="data">
            <b-link
              v-if="data.item.assigned_to_id"
              :to="{ name: 'user', params: { id: data.item.assigned_to_id } }"
            >
              {{ data.item.assigned_to_name }}
            </b-link>
          </template>
          <template #cell(checked_out_at)="data">
            <div>{{ data.item.checked_in_at | dateTimeFormat }}</div>
            <div class="text-secondary font-size-sm">
              {{ data.item.checked_out_at | dateTimeFormat }}
            </div>
          </template>
          <template #cell(overtime_hours)="data">
            {{ data.item.overtime_hours }}
          </template>
        </b-table>
        <sfs-skeleton-table
          v-else
          :rows="pagination.perPage"
          :columns="columns.length"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="auto"
        :class="{ 'mr-auto': true, 'ml-auto': !showPerPage }"
      >
        <b-pagination
          v-if="showPagination"
          v-model="pagination.currentPage"
          :total-rows="pagination.maxResults > totalRows ? totalRows : pagination.maxResults"
          :per-page="pagination.perPage"
          last-class="d-none"
        />
      </b-col>
      <sfs-pagination-dropdown
        v-if="showPerPage"
        container-class="col-auto"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
        :total-rows="totalRows"
        @per-page-changed="onPerPageChanged"
      />
    </b-row>
  </div>
</template>

<script>
import urlMixin from '@/mixins/urlMixin';
import tableMixin from '@/mixins/tableMixin';
import translationMixin from '@/mixins/translationMixin';
import { WORK_ORDER_OVERTIME_REPORT_TABLE_DEFAULT_COLUMNS } from '@/constants/reports';
import TextWithPopover from '@/components/shared/TextWithPopover.vue';

export default {
  name: 'OvertimeReportTable',
  mixins: [urlMixin, tableMixin, translationMixin],
  components: {
    TextWithPopover,
  },
  props: {
    columns: {
      type: Array,
      default: WORK_ORDER_OVERTIME_REPORT_TABLE_DEFAULT_COLUMNS,
    },
  },
  methods: {
    getRecords() {
      this.isLoadingData = true;
      this.$analyticsAPI
        .getWorkOrdersOvertimeReport(this.params)
        .then((response) => {
          const { total, records } = response;
          this.totalRows = total;
          this.records = records;
        })
        .catch(() => {
          this.records = [];
        })
        .finally(() => {
          this.loaded = true;
          this.isLoadingData = false;
          this.$emit('data-changed', this.records);
        });
    },
  },
};
</script>
